/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_AdminInputs */

const vi_nav_admin = /** @type {(inputs: Nav_AdminInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quản trị`)
};

/**

* @param {Nav_AdminInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_admin = /** @type {((inputs?: Nav_AdminInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_AdminInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_admin(inputs)
});